import { Box, BoxProps, Stack } from "@mui/material";
import PrintIcon from '@mui/icons-material/Print';
import { TFilters } from "../../../../../../components/TableDataGridV2/types";
import BtnLoading from "../../../../../../components/BasicComponents/Buttons/BtnLoading";
import moment from "moment";
import { enqueueSnackbar } from "notistack";
import { usePermission } from "../../../../../../components/PermissionGuard";
import { useMutation } from "react-query";
import axiosClient from "../../../../../../lib/axios";
import { useState } from "react";
import DialogAcompanharRelatorio from "./DialogAcompanharRelatorio";

export default function BtnImprimirRelatorio({
    boxProps,
    filters: defaultFilters
}: BtnImprimirRelatorioProps) {

    const hasPermission = usePermission("financeiro.contas-receber-imprimir-recebimentos-baixas")

    const [relatorioId, setRelatorioId] = useState<number | null>(null);

    const { mutate: gerarRelatorio, isLoading } = useMutation({
        mutationKey: "gerar-relatorio-recebimentos",
        mutationFn: (formato: 'pdf' | 'csv') =>
            axiosClient.post("/financeiro/contas-receber/gerar-recebimento-baixa", {
                ...defaultFilters,
                format: formato
            }),
        onSuccess: (data) => {
            enqueueSnackbar(`Relatório em processamento - ID: ${data.data.relatorio_id}`, { variant: 'success' })
            setRelatorioId(data.data.relatorio_id);
        },
        onError: (error) => {
            console.error("Erro ao gerar o relatório:", error);
        },
    });

    //Funções manipuladoras
    const convertFiltersToParams = (filters: TFilters): string => {
        const params = new URLSearchParams();

        Object.entries(filters).forEach(([key, value]) => {
            if (value === null || value === undefined || value === '') {
                return;
            }

            const formatDate = (v: any): string => {
                if (moment.isMoment(v)) {
                    return v.format("YYYY-MM-DD");
                }
                if (v instanceof Date) {
                    return moment(v).format("YYYY-MM-DD");
                }
                return String(v);
            };

            if (Array.isArray(value)) {
                value.forEach((item, index) => {
                    if (item !== null && item !== undefined && item !== '') {
                        params.append(`${key}[${index}]`, formatDate(item));
                    }
                });
            } else {
                params.append(key, formatDate(value));
            }
        });

        return params.toString();
    };

    const handleImprimirRelatorio = () => {
        const filterParams = convertFiltersToParams(defaultFilters);
        if (!filterParams) {
            return enqueueSnackbar("Por favor, defina pelo menos um filtro para gerar o relatório.", { variant: "warning" });
        }
        gerarRelatorio('pdf');
    };

    const handleImprimirRelatorioCSV = () => {
        const filterParams = convertFiltersToParams(defaultFilters);
        if (!filterParams) {
            return enqueueSnackbar("Por favor, defina pelo menos um filtro para gerar o relatório.", { variant: "warning" });
        }
        gerarRelatorio('csv');
    };

    return (
        <>
            <Box {...boxProps}>
                <Stack direction="row" spacing={2}>
                    <BtnLoading
                        variant="outlined"
                        size="small"
                        startIcon={<PrintIcon />}
                        loading={isLoading}
                        onClick={handleImprimirRelatorio}
                        loadingText="Gerando relatório..."
                        disabled={!hasPermission}
                    >
                        Gerar relatório PDF
                    </BtnLoading>
                    <BtnLoading
                        variant="outlined"
                        size="small"
                        startIcon={<PrintIcon />}
                        loading={isLoading}
                        onClick={handleImprimirRelatorioCSV}
                        loadingText="Gerando relatório..."
                        disabled={!hasPermission}
                    >
                        Gerar relatório CSV
                    </BtnLoading>
                </Stack>
            </Box>

            {
                relatorioId !== null &&
                <DialogAcompanharRelatorio
                    relatorioId={relatorioId}
                    open={relatorioId !== null}
                    onClose={() => setRelatorioId(null)}
                />
            }
        </>
    )
}

interface BtnImprimirRelatorioProps {
    boxProps: BoxProps
    filters: TFilters
}